import { fetchJSON } from "./utils";

export async function fetchAll(organizationId) {
  const url = "/api/web_search_topic/";
  let params = null;
  if (organizationId) {
    params = { organization_id: organizationId };
  }
  return fetchJSON(url, params, null, "get", false);
}

export async function fetchOne(id) {
  const url = `/api/web_search_topic/${id}`;
  return fetchJSON(url, null, null, "get");
}

export async function createWebSearchTopic(data) {
  const url = "/api/web_search_topic/";
  return fetchJSON(url, null, data, "post");
}

export async function updateWebSearchTopic(id, data) {
  const url = `/api/web_search_topic/${id}`;
  return fetchJSON(url, null, data, "put");
}

export async function deleteWebSearchTopic(id) {
  const url = `/api/web_search_topic/${id}`;
  return fetchJSON(url, null, null, "delete");
}

export async function getTags(organizationId) {
  const url = `/api/web_search_topic/tags`;
  let params = null;
  if (organizationId) {
    params = { organization_id: organizationId };
  }
  return fetchJSON(url, params, null, "get");
}

export async function getDomains(organizationId) {
  const url = `/api/web_search_topic/domains`;
  let params = null;
  if (organizationId) {
    params = { organization_id: organizationId };
  }
  return fetchJSON(url, params, null, "get");
}
